import React, { useContext } from 'react';
import { AdminContext } from '../../../context/admin-context';
import { MemberContext } from '../../../context/member-context';
import { Context } from '../../../context/global-data-provider';
import Replies from './replies';
import UserIcon from '../../images/user.jpg';
import Svg from '../icons/svg';

import './comment-item-style.css';

function CommentItem(props) {
  const { provider, comment } = props;
  const { options } = useContext(Context);
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);

  const removeComment = () => {
    provider.removeComment(comment.id);
  };

  return (
    <ul className="mb-16p">
      <div>
        <li className="comment-item p-relative ww-break-word">
          {admin.auth.value && (
            <button type="button" className="btn text-danger remove-comment" onClick={removeComment}>
              <Svg name={'trash'} width={14} />
            </button>
          )}
          <div className="f-row">
            <div className="user d-block p-relative o-hidden">
              {comment.fullname ? (
                <img src={comment.avatar ? comment.avatar : UserIcon} alt="User" />
              ) : (
                <img src={options.logo} alt="User" />
              )}
            </div>
            <div className="f-shrink-1 d-inline-block min-wh-0 pl-28p">
              <h2 className="d-inline-flex align-items-center">
                <div className="ml-4p f-00auto justify-content-start align-items-stretch align-content-stretch">
                  <span className="font-weight-bold font-size-4 line-height-2">
                    {comment.fullname ? comment.fullname : options.title}
                  </span>
                </div>
              </h2>
              <span className="message font-size-4 line-height-2">
                {comment.content}
                {member.auth.value && comment.member_id === member.info.id && (
                  <span
                    className="font-size-3 color-danger u-select-none c-p mr-8p"
                    onClick={removeComment}
                    style={{ position: 'absolute', whiteSpace: 'nowrap', bottom: 0 }}
                  >
                    حذف نظر
                  </span>
                )}
              </span>
            </div>
          </div>
        </li>
      </div>

      <Replies provider={provider} id={comment.id} replies={comment.replies} />

      {admin.auth.value && (
        <li className={'pl-28p d-flex f-row f-grow-1 justify-content-between px-8p py-2p border-radius-2p mt-4p'}>
          <span className={'font-size-2 font-weight-300 color-gray'}>{comment.date}</span>
          <a href={`tel:${comment.mobile}`} className={'font-size-2 font-weight-300 color-gray'}>
            {comment.mobile}
          </a>
        </li>
      )}
    </ul>
  );
}

export default CommentItem;
